import * as React from 'react';

export const useDependencyCheck = (
  componentName: string,
  ...fns: unknown[]
): void => {
  if (!import.meta.env.PROD)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(() => {
      const requiresDependencyCheck = fns.some(
        (fn) => typeof fn !== 'undefined'
      ); // atleast one of the dependent function is defined
      const isMissingDependency = fns.some((fn) => typeof fn === 'undefined'); // atleast one of the dependent function is not defined

      if (requiresDependencyCheck && isMissingDependency) {
        // if a function is defined, but it's dependednt(s) are not defined, raise warning
        console.warn(
          [
            'Component is missing dependent functions!',
            `Check the ${componentName} documentation/stories to know the usage of the component`,
          ].join('\n')
        );
      }
    }, [componentName, fns]);
};
